import { GetPublicWorkspaceMembersQuery } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getPublicWorkspaceMembersForDashboardQueryDocument } from "./public-dashboard-embed.gql";

export const useGetPublicWorkspaceMembersForDashboard = (
  dashboardId: string,
  options?: { skip?: boolean },
): {
  members: GetPublicWorkspaceMembersQuery["getPublicWorkspaceMembers"] | undefined;
  loading: boolean;
  error: unknown;
  refetch: () => Promise<unknown>;
} => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.publicDashboards.workspaceMembers(dashboardId),
    queryFn: async (): Promise<GetPublicWorkspaceMembersQuery> => {
      const client = createOperationClient("GetPublicWorkspaceMembers", true, { dashboardId });
      return await client.request(getPublicWorkspaceMembersForDashboardQueryDocument, {
        input: { dashboardId },
      });
    },
    enabled: !!dashboardId && !options?.skip,
    retry: false,
  });

  return {
    members: data?.getPublicWorkspaceMembers,
    loading: isLoading,
    error,
    refetch,
  };
};
